<template>
  <div class="box">
    <div class="chart-title">
      <span>LP HISTORY</span>
    </div>
    <e-charts :options="chartOptions" auto-resize></e-charts>
  </div>
</template>

<script>
import moment from 'moment'
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataZoom'
import state from '../state'

export default {
  props: {
    history: {
      type: Array,
      required: true,
    },
  },

  components: {
    ECharts,
  },

  computed: {
    orderedHistory () {
      return this.history
    },
    chartOptions () {
      return {
        grid: {
          left: 5,
          right: 7,
          top: 15,
          bottom: 45,
          // width: '100%',
          containLabel: true,
        },
        dataZoom: [
          {
            dataBackground: {
              lineStyle: {
                color: state.darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7',
                width: 1,
              },
              areaStyle: {
                color: state.darkThemeEnabled ? 'rgba(0,0,0,.43)' : '#F1F4F7',
                opacity: 1,
              },
            },
            fillerColor: 'rgba(0, 167, 255, .4)',
            borderColor: 'none',
            handleStyle: {
              color: 'rgba(0, 167, 255, 1)',
            },
            labelFormatter (value, valueStr) {
              return moment(valueStr).format('LLL')
            },
          },
        ],
        tooltip: {
          trigger: 'axis',
          position: 'bottom',
          formatter (params) {
            let [date, , rank, leaguePoints] = params[0]['data']
            return `
            <div style="text-align:left;">
              ${moment(date).format('LL')}<br>
              ${rank} - ${leaguePoints} LP
            <div>
            `
          },
        },
        xAxis: {
          show: true,
          type: 'category',
          silent: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter (date) {
              return moment(date).format('LL')
            },
            textStyle: {
              color: state.darkThemeEnabled ? '#F5F7F7' : '#444546',
              fontFamily: "'Avenir', Helvetica, Arial, sans-serif",
            },
          },
          axisPointer: {
            lineStyle: {
              width: 1,
              type: 'dashed',
              color: '#00A7FF',
              opacity: 0.5,
            },
          },
          axisLine: {
            lineStyle: {
              color: state.darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7',
            },
          },
          data: this.orderedHistory.map(leaguePosition => leaguePosition.date),
        },
        yAxis: {
          type: 'value',
          show: false,
          min: 'dataMin',
          axisLabel: {
            show: false,
            inside: true,
          },
        },
        visualMap: {
          show: false,
          type: 'piecewise',
          dimension: 1,
          pieces: [
            { gt: 500, lte: 1000, label: 'BRONZE', color: '#7E6E53' },
            { gt: 1000, lte: 1500, label: 'SILVER', color: '#8698A3' },
            { gt: 1500, lte: 2000, label: 'GOLD', color: '#FFBA00' },
            { gt: 2000, lte: 2500, label: 'PLATINUM', color: '#3AC1B7' },
            { gt: 2500, lte: 3000, label: 'DIAMOND', color: '#3D93DD' },
            { gt: 3000, label: 'MASTER / CHALLENGER', color: '#FFBA00' },
          ],
        },
        series: [{
          showSymbol: false,
          areaStyle: {
            normal: {
              opacity: 0.1,
            },
          },
          type: 'line',
          sampling: 'average',
          smooth: false,
          lineStyle: {
            normal: {
              width: 3,
              opacity: 1,
            },
          },
          data: this.orderedHistory.map(leaguePosition => ([leaguePosition.date, leaguePosition.score, leaguePosition.rank, leaguePosition.league_points])),
        }],
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.echarts
  width: 100%
  height: 400px

.box
  border-top: 4px solid $primary
  padding: 1rem

.chart-title
  margin-top: 1rem
  text-align: center
  span
    display: inline-block
    padding-bottom: 5px
    border-bottom: 1px solid $divider-color

.is-dark
  .chart-title span
    border-color: rgba(0,0,0,0.23)
</style>



// WEBPACK FOOTER //
// LeaguePointsHistoryGraph.vue?330b7f8c